import React from 'react'

export default props =>
    <section className="loading">
        <i class="fas fa-spinner fa-pulse"></i>
    </section>
